<template>
  <Wrapper>
    <main class="main">
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}result` }"
            class="breadcrumb-trail__list--item__link"
          >
            Results
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">Results</h1>
      <ul class="result__list">
        <li
          class="result__list--item"
          v-for="(dataEvent, index) in dataEventList"
          :key="index"
        >
          <router-link
            :to="{
              path: `/${langPath}${
                dataEvent.text.team_event_code ? 'company/' : ''
              }ranking`,
              query: {
                event: `${
                  dataEvent.text.team_event_code
                    ? dataEvent.text.team_event_code
                    : dataEvent.code
                }`,
                page: 1,
              },
            }"
            class="link"
          >
            <dl class="result-item-dl">
              <dd class="description-date">{{ dataEvent.text.event_date }}</dd>
              <dd class="blue-line"></dd>
              <dt class="team-title">
                {{ dataEvent.name }}
              </dt>
            </dl>
            <figure class="result-item-figure">
              <img
                :src="`https://tmf-virtualrun.jp/images/${dataEvent.text.event_image_file_name}`"
                alt=""
                width="52px"
                height="52px"
              />
            </figure>
          </router-link>
        </li>
      </ul>
    </main>
  </Wrapper>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
import Wrapper from "../../../components/sp/Wrapper";
export default {
  data() {
    return {
      dataEventList: [],
    };
  },
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const params = {
      lang: this.lang,
      eventPeriod: true,
    };
    const response = await EventRepository.getEventList(params);
    this.dataEventList = response.data.items;
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
  },
  name: "Result",
};
</script>

<style scoped lang="scss">
.main {
  text-align: center;
  .page-title {
    display: inline-block;
    margin: 30px 0 0 0;
    line-height: 1.33;
    font-size: 50px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_results.svg");
      background-size: 101%;
    }
  }
  .result__list {
    margin: 20px 0 0 0;
    text-align: left;
    &--item {
      border-bottom: solid 1px var(--defaultBlackColor);
      .link {
        display: flex;
        align-items: center;
        padding: 20px 0;
        .result-item-dl {
          .description-date {
            font-size: 16px;
            font-weight: bold;
          }

          .blue-line {
            margin: 8px 0;
            width: 60px;
            border-top: solid 6px var(--blueFoundationColor);
          }

          .team-title {
            font-size: 20px;
            font-weight: bold;
          }
        }

        .result-item-figure {
          margin: 0 0 0 10px;
          padding: 5px;
          border: solid 1px var(--defaultGrayColor);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/result/Result.vue